import clsx from 'clsx'

type Option<T> = {
  value: T
  label: string
}

type SelectProps<T> = {
  onChange: (val: T) => void
  options: Option<T>[]
  value?: T
  inputSize?: 'small' | 'medium' | 'large'
} & React.ComponentProps<'select'>

export const Select = <T extends string>(props: SelectProps<T>) => {
  const { onChange, options, value, inputSize = 'medium', ...rest } = props

  const sizeClasses = {
    small: 'px-2 py-1 text-sm',
    medium: 'px-4 py-2 text-xs font-normal',
    large: 'px-6 py-2 text-lg',
  }

  return (
    <select
      className={clsx(
        'block w-full border-0 text-gray-900 shadow-sm ring-1 ring-gray-900/20 placeholder:text-gray-400 focus:ring-2 focus:ring-inset',
        sizeClasses[inputSize],
        'rounded-md',
        rest.className
      )}
      onChange={(e) => onChange(e.target.value as T)}
      value={value}
      {...rest}>
      {options.map(({ value, label }) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>
  )
}
